export default "__VITE_ASSET__Dk7YHfms__"